import { Injectable } from '@angular/core';
import { StorageService } from '@shared';

@Injectable({ providedIn: 'root' })
export class ConnectionProviderService {
	private ConnectionIdKey = 'CONNECTION_ID';

	public constructor(private storageService: StorageService) {}

	public async save(connectionId: string): Promise<void> {
		await this.storageService.set(this.ConnectionIdKey, connectionId);
	}

	public async get(): Promise<string> {
		return await this.storageService.get(this.ConnectionIdKey);
	}
}
